import {Component, Input, OnInit} from '@angular/core';
import {Router} from "@angular/router";

@Component({
  selector: 'app-category-dropdown',
  templateUrl: './category-dropdown.component.html',
  styleUrls: ['./category-dropdown.component.scss']
})
export class CategoryDropdownComponent implements OnInit {

  @Input() categories: any = [];
  @Input() categoryName: string = '';
  @Input() categoryId: number = 0;
constructor(private router: Router) {
}

  ngOnInit(): void {
    /**/
  }
  categoriesClick(id:any){
    this.router.navigate(['category', id],{
      queryParams: {
        tenantId: localStorage.getItem("tenantId"),
        lang:localStorage.getItem("lang")
      },
      queryParamsHandling: 'merge',
    })
  }
}
